// extracted by mini-css-extract-plugin
export default {"containerOptionCheckbox":"CheckBox_containerOptionCheckbox__kfN8-","checkbox--error":"CheckBox_checkbox--error__JCZmu"};